import { constants } from './../constants';
import { TextPpt } from "../interfaces";
import PptxGenJS from 'pptxgenjs';

export const createTextOptions = (
    position: { x: number; y: number },
    availableWidth: number,
    textHeight: number,
    fontSize: number
): PptxGenJS.TextPropsOptions => {
    const marginTop = (constants.DEFAULT_MARGIN[0] ?? 0) * constants.POINT_TO_INCH_FACTOR;
    const marginBottom = (constants.DEFAULT_MARGIN[3] ?? 0) * constants.POINT_TO_INCH_FACTOR;

    return {
        x: position.x,
        y: position.y,
        w: availableWidth - position.x - constants.WIDTH_ADJUSTMENT,
        h: textHeight,
        fontSize: fontSize,
        valign: constants.DEFAULT_VALIGN as PptxGenJS.VAlign,
        margin: constants.DEFAULT_MARGIN as PptxGenJS.Margin,
    };
};

export const textProposToTextPpt = (textObjects: PptxGenJS.TextProps[]): TextPpt[] => {
    return textObjects.map((value) => {
        const fontSize = value.options?.fontSize ?? constants.DEFAULT_FONT_SIZE;

        return {
            ...value,
            fontSize,
            fontSizeInch: fontSize * constants.POINT_TO_INCH_FACTOR,
        };
    });
};

export const calculateTextHeightPerFragment = (
    textObjects: TextPpt[],
    availableWidth: number,
    positionX: number
): number => {
    const toleranceFactor = 0.88; // Optimized for accurate rendering
    const emptyLineHeightFactor = 0.55;

    return textObjects.reduce((totalHeight, obj) => {
        const text = obj.text ?? '';
        const fontSize = obj.fontSize ?? constants.DEFAULT_FONT_SIZE;
        const isBold = obj.options?.bold ?? false;

        const lineHeightFactor = fontSize <= 8 ? 0.85 : constants.LINE_HEIGHT_FACTOR;
        const lineHeight = fontSize * constants.POINT_TO_INCH_FACTOR * lineHeightFactor;

        const availableInches = (availableWidth - positionX - constants.WIDTH_ADJUSTMENT) * toleranceFactor;

        const baseCharWidth = 0.11; // dla 10 pt
        const charWidth = Math.max(0.06, baseCharWidth * (fontSize / 10)) * (isBold ? 1.15 : 1.0);

        const lines = text.split('\n');
        let totalLines = 0;

        for (const line of lines) {
            const trimmed = line.trim();

            if (trimmed === '') {
                totalLines += emptyLineHeightFactor;
                continue;
            }

            const words = trimmed.split(/\s+/);
            let currentLineWidth = 0;
            let lineCount = 1;

            for (const word of words) {
                const wordWidth = word.length * charWidth;
                if (currentLineWidth + wordWidth > availableInches) {
                    lineCount++;
                    currentLineWidth = wordWidth;
                } else {
                    currentLineWidth += wordWidth + charWidth;
                }
            }

            totalLines += lineCount;
        }

        const contentHeight = totalLines * lineHeight;
        return totalHeight + contentHeight;
    }, 0);
};